import styled from 'styled-components';
import { colors } from 'assets/styled/tokens';

export const StyledError = styled.div`
  display: block;
  transform: translateY(2px);
  font-size: 12px;
  margin-left: 2px;
  transition: all 300ms ease;
  color: ${colors.cedar};
`;
